import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface RedirectStore {
  route?: {
    path: string;
    params?: {
      [key: string]: any;
    };
  };
  setRoute: (route?: {
    path: string;
    params?: {
      [key: string]: any;
    };
  }) => void;
}

export const useRedirectStore = create<RedirectStore>()(
  devtools((set) => ({
    route: undefined,
    setRoute: (route) => {
      return set({ route });
    },
  }))
);
